import { useQuery } from '@apollo/client';
import { isNil } from 'lodash';
import { Queries } from '@shared/api';
import { API } from '@shared/types/api';
import { useCurrentBusinessId } from './useCurrentBusinessId';

export function useCurrentBusiness(): API.BusinessFragment | undefined {
  const businessId = useCurrentBusinessId();
  const { data } = useQuery<API.GetBusinessQuery, API.GetBusinessQueryVariables>(
    Queries.business.getBusiness,
    {
      variables: { id: businessId ?? -1 },
      skip: isNil(businessId),
    },
  );
  return data?.business ?? undefined;
}
